import { useEffect, useState } from "react";
// import httpClient from "../HTTPService";
import httpClient from "../../HTTPService";
import { Tooltip as ReactTooltip } from "react-tooltip";

import moment from "moment";

function DatewiserevenueData() {
    const [rportsList, setReportslist] = useState()
    const [searchtext, setsearchtext] = useState('')
    const [totalCount, setTotalCount] = useState(0)
    const [currentPage, setCurrentPage] = useState(1);
    const [getLimit, setLimit] = useState(10);
    const items = Array.from({ length: totalCount }, (_, index) => `Item ${index + 1}`);
    const itemsPerPage = 10;
    const totalPages = Math.ceil(items.length / getLimit);
    const startPage = Math.max(1, currentPage - Math.floor(5 / 2));
    const endPage = Math.min(totalPages, currentPage + Math.floor(5 / 2));

    const [fromDate, setFDromadate] = useState('')
    const [toDate, setToDate] = useState('');
    const [dateProfitDetails, setDateOrofitdetails] = useState([])
    const [totalpayammount, setToalPayamount] = useState({
        addprofit: 0,
        services: 0,
        both_total: 0,
        Total_dis: 0,
        net_profit: 0
    })
    useEffect(() => {
        fetchapproavedlistdata(searchtext, currentPage, getLimit);
    }, [currentPage, getLimit]);

    const [memberDetailsLoading, setMemberDetailsLoading] = useState(false);
    const handlePageChange = (page) => {
        setCurrentPage(page);
    };
    //search button

    const searchtxt = () => {
        fetchapproavedlistdata(searchtext, 1, getLimit);
    }
    //pagiantion

    const Pagination = ({ currentPage, totalPages, onPageChange }) => {
        const pages = [];
        for (let i = 1; i <= totalPages; i++) {
            pages.push(i);
        }
        console.log(currentPage, 'current pages...')
        return (
            <div className="pagination">
                {currentPage > 1 && (
                    <button className="pagination-btn" onClick={() => onPageChange(currentPage - 1)}>
                        <i className="fa fa-chevron-left" aria-hidden="true"></i>
                    </button>
                )}
                {startPage > 1 && (
                    <button className="pagination-btn" onClick={() => onPageChange(1)}>
                        1
                    </button>
                )}
                {startPage > 2 && <span className="pagination-ellipsis">...</span>}
                {pages.slice(startPage - 1, endPage).map(page => (
                    <button
                        key={page}
                        className={`pagination-btn ${page === currentPage ? 'active' : ''}`}
                        onClick={() => onPageChange(page)}
                    >
                        {page}
                    </button>
                ))}
                {endPage < totalPages - 1 && <span className="pagination-ellipsis">...</span>}
                {endPage < totalPages && (
                    <button className="pagination-btn" onClick={() => onPageChange(totalPages)}>
                        {totalPages}
                    </button>
                )}
                {currentPage < totalPages && (
                    <button className="pagination-btn" onClick={() => onPageChange(currentPage + 1)}>
                        <i className="fa fa-chevron-right" aria-hidden="true"></i>
                    </button>
                )}
            </div>
        );
    };
    // get reports


    const fetchapproavedlistdata = async (search_name, pagecount, limit) => {
        try {
            const result = await httpClient.post("/admin/profit-list", {
                search_name, search_status: 1,
                from_date: fromDate,
                to_date: toDate,
                // offset: pagecount, limit: limit
            }, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });
            console.log(result.data.data);
            if (result.data.status == true) {
                console.log(result?.data?.data, 'data list....');
                setTotalCount(result?.data.total_count)
                setReportslist(result?.data?.data)
                calcualte_totalpayamount(result?.data?.data)
                // location.state = null
                // toast.success(result.data.message)
            }
            if (result.data.status == false) {
                // toast.error(result.data.message)

            }

        }

        catch (error) {
            // toast.error(error.message)
        }
    }

    // revinue list
    function calcualte_totalpayamount(_input) {
        console.log(Object.values(_input), 'input datatat')
        let _returnInputData = Object.values(_input)?.map(item => ({
            ...item
        }))

        // console.log(_returnInputData ,'datatt input')
        //    const result = data.map(item => Object.values(item));
        let addprofit = 0;
        let services = 0;
        let both_total = 0;
        let Total_dis = 0;
        let net_prarrayofit = 0;
        _returnInputData?.forEach(item => {
            addprofit += item?.profile_added_revenue ? parseFloat(item?.profile_added_revenue) : 0;
            services += item?.service_added_revenue ? parseFloat(item?.service_added_revenue) : 0;
            both_total += item?.total_revenue ? parseFloat(item?.total_revenue) : 0;
            Total_dis += item?.total_distribution ? parseFloat(item?.total_distribution) : 0;
            net_prarrayofit += item?.net_profile ? parseFloat(item?.net_profile) : 0
        });
        console.log({

            addprofit: addprofit?.toFixed(2),
            services: services?.toFixed(2),
            both_total: both_total?.toFixed(2),
            Total_dis: Total_dis?.toFixed(2),
            net_profit: net_prarrayofit?.toFixed(2)

        }, 'profit data details/////')
        setToalPayamount({
            addprofit: addprofit?.toFixed(2),
            services: services?.toFixed(2),
            both_total: both_total?.toFixed(2),
            Total_dis: Total_dis?.toFixed(2),
            net_profit: net_prarrayofit?.toFixed(2)
        })
    }
    // fetch date profit details
    const fetDateprofitdetails = async (date) => {
        setMemberDetailsLoading(true);
        try {
            const result = await httpClient.post("/admin/profile-details", {
                date: date
                // offset: pagecount, limit: limit
            }, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });
            // console.log(result.data.data);
            if (result.data.status == true) {
                setMemberDetailsLoading(false);

                setDateOrofitdetails(result?.data?.data?.concat(result?.data?.data2));

            }
            if (result.data.status == false) {
                // toast.error(result.data.message)

            }

        }

        catch (error) {
            // toast.error(error.message)
        }
    }
    return (
        <>
            <div className="">
                <div class="search-box">
                    <div class="searchtct " style={{
                        display: 'flex',
                        flexDirection: 'column',
                        marginRight: 20
                    }}>
                        <label>From</label>
                        <input
                            value={fromDate}
                            onChange={(e) => setFDromadate(e.target?.value)}
                            type='date' name='date' placeholder='Select Date'></input>


                    </div>
                    <div class="searchtct" style={{
                        display: 'flex',
                        flexDirection: 'column'
                    }}>

                        <label>To</label>
                        <input
                            value={toDate}
                            onChange={(e) => setToDate(e.target?.value)}
                            type='date' name='date' placeholder='Select Date'></input>



                    </div>
                    <div class="searchtct" style={{
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                        <button type='button' className='searchBtn' onClick={searchtxt} >Search</button>

                    </div>
                </div>
                <h4>Revenue & Net Profit: {totalCount}</h4>
                <div class="row">
                    <div class="col-md-12">
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th>SL NO</th>
                                        <th>Date</th>
                                        <th>Revenue Profile Adder(₹)</th>
                                        <th>Revenue Service User(₹)</th>
                                        <th>Total Both Together(₹)</th>
                                        <th>Distribution(₹)</th>
                                        <th>Net Profit(₹)</th>
                                        <th style={{
                                            textAlign:'center'
                                        }}>View</th>


                                    </tr>
                                </thead>
                                <tbody>

                                    {
                                        rportsList && Object.values(rportsList)?.flatMap((item, index) => {
                                            const serialNumber = (currentPage - 1) * getLimit + index + 1;

                                            return (
                                                <tr className="custom-tableback-th">
                                                    <td className="col-1">{serialNumber}</td>
                                                    <td className="col-1">{moment(item.date).format('DD/MM/YYYY')}</td>
                                                    <td className="col-1 table-td" >
                                                        {item?.profile_added_revenue}

                                                    </td>
                                                    <td className="col-1 table-td">{item?.service_added_revenue}</td>
                                                    <td className="col-1 table-td">

                                                        {item?.total_revenue}


                                                    </td>
                                                    <td className="col-1 table-td">{item?.total_distribution}</td>
                                                    <td className="col-1 table-td">{item?.net_profile}</td>
                                                    <td>
                                                        <div className='table-column'>
                                                            <i
                                                                data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight"

                                                                onClick={() => {
                                                                    fetDateprofitdetails(item?.date)
                                                                }}
                                                                // onClick={() => navigate(`/profile-request-details/${item?.id}`)}
                                                                class="fa fa-eye" aria-hidden="true"></i>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )
                                        })
                                    }
                                    <tr className="custom-tableback-th">
                                        <td className="col-1"></td>
                                        <td className="col-1"></td>
                                        <td className="col-1 table-td" >
                                            TO: {totalpayammount.addprofit}

                                        </td>
                                        <td className="col-1 table-td">TO: {totalpayammount.services}</td>

                                        <td className="col-1 table-td">

                                            TO:  {totalpayammount.both_total}


                                        </td>
                                        <td className="col-1 table-td">TO: {totalpayammount.Total_dis}</td>
                                        <td className="col-1 table-td">TO: {totalpayammount.net_profit}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <div className='nodata-found-div'>
                                {
                                    rportsList?.length == 0 ?
                                        <p>No Data Found</p>
                                        //  <img 
                                        //  className='table-image'
                                        //  src={require('../../assets/OIP.png')}/>
                                        : null
                                }
                            </div>
                        </div>
                    </div>
                </div>

                {/* <div class="row total_amount_display">
          <div class="col-md-8">
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th>SL NO</th>
                  </tr>
                </thead>
              </table>
            </div>
          </div>
        </div> */}
                {/* <div class="tablepgntn">
                    <p>Show <select value={getLimit} onChange={(val) => {
                        setLimit(val.target.value);
                        setCurrentPage(1)
                    }}>
                        <option value={10}>10</option>
                        <option value={20}>20</option>
                        <option value={30}>30</option>
                        <option value={40}>40</option>
                        <option value={50}>50</option>
                    </select> Entries</p>
                    <ul>

                    </ul>
                    <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={handlePageChange}
                    />

                </div> */}

                <div
                    style={{ width: '80vw', maxWidth: '56vw', height: '100vh' }}
                    class="offcanvas offcanvas-end " tabindex="-1" id="offcanvasRight" aria-labelledby="offcanvasRightLabel">
                    <div class="offcanvas-header">
                        <h5 class="offcanvas-title" id="offcanvasRightLabel">Details</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>

                    </div>
                    {/* <div style={{
          paddingLeft: 20
        }}>
          <h6>User Name: {currentmemberdetails?.user_name}</h6>
          <h6>Member ID: {currentmemberdetails?.user_referral_code}</h6>
        </div> */}

                    {
                        memberDetailsLoading ? (
                            <div style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                padding: 10
                            }}>

                                <span class="loader"></span>
                            </div>
                        ) :
                            (
                                <>
                                    <div class="offcanvas-body">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="table-responsive">
                                                    <table class="table">
                                                        <thead>
                                                            <tr>
                                                                <th>SL NO</th>
                                                                <th>Date</th>
                                                                <th >
                                                                    Member Name

                                                                </th>
                                                                <th>Sub-category </th>
                                                                <th>Revenue(<i className="fa fa-inr" />)</th>

                                                                <th>Type</th>



                                                            </tr>
                                                        </thead>
                                                        {
                                                            !memberDetailsLoading && (
                                                                <tbody>
                                                                    {
                                                                        dateProfitDetails?.map((item, index) => {
                                                                            return (
                                                                                <tr>
                                                                                    <td>{index + 1}</td>
                                                                                    <td>{moment(item?.date).format('DD-MM-YYYY')}</td>
                                                                                    <td >
                                                                                        {item?.user_name}

                                                                                    </td>
                                                                                    <td>{item?.sub_category_name}</td>
                                                                                    <td style={{
                                                                                        textAlign:'center'
                                                                                    }}>{item?.price}</td>

                                                                                    <td>
                                                                                        {
                                                                                            item?.is_renue == 1 ? 'Renewal' :
                                                                                                item?.type == 'Used' ? 'Used service' : item?.type}

                                                                                    </td>
                                                                                </tr>
                                                                            )
                                                                        })
                                                                    }

                                                                    {/* {
                                  meberdetails?.map((item, index) => {

                                    return (
                                      <tr>
                                        <td style={{
                                          backgroundColor: item?.is_renue == 1 ? '#c0cfc4' : '',
                                          color: '#000000',
                                        }}>{index + 1}</td>
                                        <td className='' style={{
                                          backgroundColor: item?.is_renue == 1 ? '#c0cfc4' : '',
                                          color: '#000000',
                                        }}>
                                          {item?.sub_category_name}
                                        </td  >
                                        <td style={{
                                          textAlign: 'center',
                                          backgroundColor: item?.is_renue == 1 ? '#c0cfc4' : '',
                                          color: '#000000',
                                        }}>{item?.price}</td>
                                        <td style={{
                                          backgroundColor: item?.is_renue == 1 ? '#c0cfc4' : '',
                                          color: '#000000',
                                        }}>
                                          {moment(item?.date).format('DD-MM-YYYY')}
                                        </td>

                                        <td style={{
                                          textAlign: 'center',
                                          backgroundColor: item?.is_renue == 1 ? '#c0cfc4' : '',
                                          color: '#000000',
                                        }}>{item?.level_1_commission}</td>
                                        <td style={{
                                          textAlign: 'center',
                                          backgroundColor: item?.is_renue == 1 ? '#c0cfc4' : '',
                                          color: '#000000',
                                        }}>{item?.level_2_commission}</td>
                                        <td style={{
                                          textAlign: 'center',
                                          backgroundColor: item?.is_renue == 1 ? '#c0cfc4' : '',
                                          color: '#000000',
                                        }}> {item?.total_distribution}</td>
                                        <td style={{
                                          textAlign: 'center',
                                          backgroundColor: item?.is_renue == 1 ? '#c0cfc4' : '',
                                          color: '#000000',
                                        }}>{item?.profit}</td>
                                      
                                      </tr>
                                    )
                                  })
                                } */}
                                                                    {/* <tr>
                                  <td></td>
                                  <td>

                                  </td>
                                  <td style={{
                                    textAlign: 'center'
                                  }}>TO: {totalpayammount_detai?.payamount}</td>
                                  <td className="prioce_itd"> ---</td>

                                  <td style={{
                                    textAlign: 'center'
                                  }}>To: {totalpayammount_detai?.up1_amount}</td>
                                  <td style={{
                                    textAlign: 'center'
                                  }}>To: {totalpayammount_detai?.up2_amount}</td>
                                  <td style={{
                                    textAlign: 'center'
                                  }}>To: {totalpayammount_detai?.Total_dis}</td>
                                  <td style={{
                                    textAlign: 'center'
                                  }}>To: {totalpayammount_detai?.net_profit}</td>
                                 


                          
                                </tr>                          */}
                                                                </tbody>
                                                            )
                                                        }

                                                    </table>
                                                    {/* <div className='nodata-found-div'>

                          {
                            memberDetailsLoading ? (
                              <span class="loader"></span>
                            ) : (
                              <>
                                {
                                  meberdetails?.length == 0 ?
                                    <p>No Data Found</p>

                                    : null
                                }
                              </>
                            )

                          }
                        </div> */}
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </>
                            )
                    }

                </div>
            </div>

        </>
    )
}
export default DatewiserevenueData